var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from '../../../Input';
import Counter from './components/Counter';
import styled from 'styled-components';
import Button from '../../../Button';
import t from '../../../../lib/translate';
export var StyledPagination = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  .pagination-input-wrapper{\n    display: flex;\n    align-items: baseline;\n    .pagination-input {\n      height: 20px;\n      width: 50px;\n      margin-left: 10px;\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  .pagination-input-wrapper{\n    display: flex;\n    align-items: baseline;\n    .pagination-input {\n      height: 20px;\n      width: 50px;\n      margin-left: 10px;\n    }\n  }\n"])));
var Pagination = function (_a) {
    var activePage = _a.activePage, itemsCountPerPage = _a.itemsCountPerPage, totalItemsCount = _a.totalItemsCount, onChange = _a.onChange, previousPage = _a.previousPage, nextPage = _a.nextPage, canPreviousPage = _a.canPreviousPage, canNextPage = _a.canNextPage, usedByTable = _a.usedByTable;
    var numberOfPages = totalItemsCount === 0 ? 1 : Math.ceil(totalItemsCount / itemsCountPerPage);
    var handleChangePageInput = function (event) {
        var _a;
        if (usedByTable) {
            var page = ((_a = event === null || event === void 0 ? void 0 : event.currentTarget) === null || _a === void 0 ? void 0 : _a.value) ? Number(event.currentTarget.value) - 1 : 0;
            onChange(page);
        }
        else {
            onChange(+event.currentTarget.value);
        }
    };
    var prevPageDisabled = function () {
        if (canPreviousPage === undefined) {
            return activePage === 1;
        }
        else {
            return !canPreviousPage;
        }
    };
    var nextPageDisabled = function () {
        if (canNextPage === undefined) {
            return activePage === numberOfPages;
        }
        else {
            return !canNextPage;
        }
    };
    var handlePreviousPageClick = function () {
        if (previousPage) {
            previousPage();
        }
        else {
            onChange(activePage - 1);
        }
    };
    var handleNextPageClick = function () {
        if (nextPage) {
            nextPage();
        }
        else {
            onChange(activePage + 1);
        }
    };
    return (_jsxs(StyledPagination, { children: [_jsx(Button, { onClick: function () { return handlePreviousPageClick(); }, disabled: prevPageDisabled(), text: t('table.pagination.prev') }), _jsx(Counter, { activePage: activePage, totalPages: numberOfPages }), _jsxs("div", __assign({ className: "pagination-input-wrapper" }, { children: [_jsx("div", { children: t('table.pagination.go.to.page') }), _jsx(Input, { className: "pagination-input", value: activePage, type: "number", onChange: handleChangePageInput, disabled: numberOfPages === 1, max: numberOfPages, min: "1" })] })), _jsx(Button, { onClick: function () { return handleNextPageClick(); }, disabled: nextPageDisabled(), text: t('table.pagination.next') })] }));
};
export default Pagination;
var templateObject_1;
